import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Button } from "semantic-ui-react";
import UpdateAxios from '../axiosComponent/update';
import ModalCancelShipment from './modalcancelshipment';
import { connect } from "react-redux";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../redux/actions/alertAction";

const ShipmentDetailsHeader = (props) => {

    const cancelShipment = () => {
        // let shipmentId = props.location.search.split("=")[1];
        console.log(props);
        UpdateAxios({
            patchURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${props.shipment}/cancel`,
        })
            .then((res) => {
                // this.props.create(temShipment);
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <React.Fragment>
            <div id="dispatch_bar">
                <div className="container-fluid dip_bar">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between">
                                <h2 className="page-title">{props.title}</h2>
                                <div className="form-inline">
                                    {/* <Link
                                hidden={Permissions}
                                to={props.to}
                                className="text-decoration-none w3-button w3-hover-border-black w3-hover-white w3-border-light-grey w3-small ml-1 w3-border w3-round"
                                >
                                <i className="fas fa-pen"></i> {"Edit"}
                                </Link> &nbsp;&nbsp;&nbsp; */}
                                    {props.iscancel == false ? (
                                        <>
                                        {props.order && props.order.allotment_status && props.order.allotment_status.allotment_code == "COMPLETE" ? (null) : (
                                            <>
                                                {props.cancel == true ? (
                                            <ModalCancelShipment success={successAlertDispatcher} error={errorAlertDispatcher} shipment={props.shipment} />
                                        ) : (null)}
                                            </>
                                        )}
                                        
                                        </>
                                        
                                    ) : (
                                            null
                                        )}
                                 &nbsp;&nbsp;&nbsp;
                                <Link to={props.LinkName}><i className="fas fa-times"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(ShipmentDetailsHeader)
